@use "../../styles/mixins/component-wrapper" as wrapper;

@include wrapper.layered-component {
  hr {
    background: var(--semantic-color-border-tertiary-resting);
    width: 100%;
    height: var(--semantic-dimension-static-25);
    border-width: 0;
  }
}
